import ReadReceiptCTA from "./ReadReceiptCTA";

export default ReadReceiptCTA;



// WEBPACK FOOTER //
// ./src/apps/messenger/components/ReadReceiptCTA/index.jsx